import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getRightPackageUom } from "../../../util/function";

const ProceduresView = ({ procedures, isAdminister = false }) => {
  const { clinicStocks } = useSelector((state) => state?.clinic);

  const reqAdminList = () => {
    return procedures
      ?.flatMap((proc) => proc?.procedureDetails || [])
      ?.filter((det) => det?.type === "Administered" && det?.status === "true");
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId,
    );
    return reqStock?.stockBatch ?? [];
  };

  const renderAdministerRecord = () => {
    return (
      <div>
        {/* <div className="blk-hor-split mv3" /> */}
        <div className="flex-row-ali-cen ph10">
          <div className="w40Per">
            <Typography className="fs12 txt-semi-bold black">Name</Typography>
          </div>
          <div className="w10Per">
            <Typography className="fs12 txt-semi-bold black">
              Quantity
            </Typography>
          </div>
          <div className="w20Per">
            <Typography className="fs12 txt-semi-bold black">
              Batch Number
            </Typography>
          </div>
          <div className="w20Per">
            <Typography className="fs12 txt-semi-bold black">Dosage</Typography>
          </div>
          <div className="w10Per">
            <Typography className="fs12 txt-semi-bold black">Route</Typography>
          </div>
        </div>
        <div className="blk-hor-split mb3 mt10" />
        {reqAdminList()?.map((li, i) => {
          return (
            <div className="flex-row ph10 mv5" key={`${li?.detailId}-${i}`}>
              <div className="w40Per pr5">
                <Typography className="fs12 font-medium black4">
                  {li?.procedureName}
                </Typography>
              </div>
              <div className="w10Per pr5">
                <Typography className="fs12 font-medium black4">
                  {li?.quantity ?? "1"}
                </Typography>
              </div>
              <div className="w20Per pr5">
                <Typography className="fs12 font-medium black4">
                  {getBatchList(li?.stockId)?.find(
                    (bat) => bat?.batchId === li?.batchId,
                  )?.batchNo ?? ""}
                </Typography>
              </div>
              <div className="w20Per pr5">
                <Typography className="fs12 font-medium black4">
                  {li?.dosage ?? ""}
                  {getRightPackageUom(
                    li?.batchId
                      ? (getBatchList(li?.stockId)?.find(
                          (bat) => bat?.batchId === li?.batchId,
                        )?.packageUom ?? "")
                      : (getBatchList(li?.stockId)?.[0]?.packageUom ?? ""),
                    true,
                  )}
                </Typography>
              </div>
              <div className="w10Per">
                <Typography className="fs12 font-medium black4">
                  {li?.route ?? ""}
                </Typography>
              </div>
            </div>
            // <div className="gray-back-con1 mv5" key={`${li?.detailId}-${i}`}>
            //   <div className="flex-row-ali-cen flex-row-wrap">
            //     <Typography className="txt-semi-bold black fs12">
            //       Name: {li?.procedureName}
            //     </Typography>
            //     <div className="gray-dot2 mh5" />
            //     <Typography className="font-medium black4 fs12">
            //       Quantity:
            //     </Typography>
            //     <Typography className="txt-regular black4 fs12 ml5">
            //       {li?.quantity ?? "1"}
            //     </Typography>
            //     <div className="gray-dot2 mh5" />
            //     <Typography className="font-medium black4 fs12">
            //       Batch Number:
            //     </Typography>
            //     <Typography className="txt-regular black4 fs12 ml5">
            //       {getBatchList(li?.stockId)?.find(
            //         (bat) => bat?.batchId === li?.batchId
            //       )?.batchNo ?? ""}
            //     </Typography>
            //     <div className="gray-dot2 mh5" />
            //     <Typography className="font-medium black4 fs12">
            //       Dosage:
            //     </Typography>
            //     <Typography className="txt-regular black4 fs12 ml5">
            //       {li?.dosage ?? ""}
            //       {getRightPackageUom(
            //         li?.batchId
            //           ? getBatchList(li?.stockId)?.find(
            //               (bat) => bat?.batchId === li?.batchId
            //             )?.packageUom ?? ""
            //           : getBatchList(li?.stockId)?.[0]?.packageUom ?? ""
            //       )}
            //     </Typography>
            //     <div className="gray-dot2 mh5" />
            //     <Typography className="font-medium black4 fs12">
            //       Route:
            //     </Typography>
            //     <Typography className="txt-regular black4 fs12 ml5">
            //       {li?.route ?? ""}
            //     </Typography>
            //   </div>
            // </div>
          );
        })}
        {/* <div className="blk-hor-split mv3" /> */}
      </div>
    );
  };

  const renderRecord = () => {
    return (
      <div>
        {/* <div className="blk-hor-split mv3" /> */}
        <div className="flex-row-ali-cen ph10">
          <div className="w75Per">
            <Typography className="fs12 txt-semi-bold black">Name</Typography>
          </div>
          <div className="w25Per">
            <Typography className="fs12 txt-semi-bold black">
              Service Type
            </Typography>
          </div>
        </div>
        <div className="blk-hor-split mb3 mt10" />
        {procedures?.map((li, i) => {
          return (
            <div className="flex-row ph10 mv5" key={`${li?.procedureId}-${i}`}>
              <div className="w75Per pr5">
                <Typography className="fs12 font-medium black4">
                  {li?.procedureName}
                </Typography>
              </div>
              <div className="w25Per pr5">
                <Typography className="fs12 font-medium black4">
                  {li?.serviceType ?? ""}
                </Typography>
              </div>
            </div>
            // <div className="gray-back-con1 mv5" key={`${li?.procedureId}-${i}`}>
            //   <div className="flex-row-ali-cen flex-row-wrap">
            //     <Typography className="txt-semi-bold black fs12">
            //       Name: {li?.procedureName}
            //     </Typography>
            //     <div className="gray-dot2 mh5" />
            //     <Typography className="font-medium black4 fs12">
            //       Service Type:
            //     </Typography>
            //     <Typography className="txt-regular black4 fs12 ml5">
            //       {li?.serviceType ?? ""}
            //     </Typography>
            //   </div>
            // </div>
          );
        })}
        {/* <div className="blk-hor-split mv3" /> */}
      </div>
    );
  };

  return <div>{isAdminister ? renderAdministerRecord() : renderRecord()}</div>;
};

export default ProceduresView;
